import Card from "./Card";
import Loader from "./Loader";

const PageGridAlt = ({data})=>{
    return <>
    {
         (data.length>0)?
        <section className="grid lg:grid-cols-5 md:grid-cols-4 grid-cols-2 md:gap-2 gap-1 px-2 md:px-4 lg:px-8  shrink mt-8 justify-items-center">
        {
        
            data.map(item=>{
                return <Card movie={item} key={item.id}/>
            }) 
            
        }
        </section>
        :
        <Loader/>
    }
    </>
}

export default PageGridAlt